import React from "react";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import { exportToSalesforcePopupState } from "Components/common/ExportToSalesforcePopup";
import { exportToZohoPopupState } from "Components/common/ExportToZohoPopup";

// "Connect <crm>" / "Configure field mapping" prompts shown before a CRM contact export (same copy as the Contacts page).

export const resetCrmExportPopups = () => {
  exportToSalesforcePopupState.setBtnLoader(false);
  exportToSalesforcePopupState.setSelectedKey("lead");
  exportToSalesforcePopupState.setShowPopup(false);
  exportToZohoPopupState.setBtnLoader(false);
  exportToZohoPopupState.setSelectedKey("lead");
  exportToZohoPopupState.setShowPopup(false);
  confirmationPopupState.setShowPopup(false);
};

const goToCrmSettings = (history, path) => {
  localStorage.setItem(
    "goBackUrl",
    `${history.location.pathname}${history.location.hash}`
  );
  history.push(path);
};

export const crmExportNotConnected = (type = "", history) => {
  confirmationPopupState.setPopupValues({
    content: (
      <div className="crmExportNotConnectedWrapper">
        <div className="initText">
          {`Connect your ${type} CRM to export contacts seamlessly.`}
        </div>
      </div>
    ),
    actionBtnText: `Connect ${type}`,
    cancelCbk: resetCrmExportPopups,
    callback: () =>
      goToCrmSettings(history, `/settings/crm/${type}?source=contact`),
    dynamicDom: true
  });
  confirmationPopupState.setShowPopup(true);
};

export const crmExportNotMapped = (
  type = "",
  history,
  selectedEntity = "contacts"
) => {
  confirmationPopupState.setPopupValues({
    content: (
      <div className="crmExportNotMapped">
        <div className="initText">
          {`Set up your field mappings to export ${selectedEntity} from Salesgear to ${type}.`}
        </div>
        <div className="noteText">
          Note: Only fields marked for ‘2-way sync’ or ‘outbound’ will be
          exported. Fields set as ‘inbound’ will not be exported.
        </div>
      </div>
    ),
    actionBtnText: "Configure field mapping",
    cancelCbk: resetCrmExportPopups,
    callback: () =>
      goToCrmSettings(
        history,
        `/settings/crm/${type}?source=contact#${selectedEntity}`
      ),
    dynamicDom: true
  });
  confirmationPopupState.setShowPopup(true);
};
